import { render, staticRenderFns } from "./ClosingsDetails.vue?vue&type=template&id=52f640e0"
import script from "./ClosingsDetails.vue?vue&type=script&lang=js"
export * from "./ClosingsDetails.vue?vue&type=script&lang=js"
import style0 from "./ClosingsDetails.vue?vue&type=style&index=0&id=52f640e0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52f640e0')) {
      api.createRecord('52f640e0', component.options)
    } else {
      api.reload('52f640e0', component.options)
    }
    module.hot.accept("./ClosingsDetails.vue?vue&type=template&id=52f640e0", function () {
      api.rerender('52f640e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popups/closings-details/ClosingsDetails.vue"
export default component.exports